// Author Lin
// Date 2021-11-25 20:11:55

class MintalMesPrdSmeltingThickenerPump {
        constructor({
                id = null,
                measureTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                thickenerRakePressure = '',
                pressure606 = '',
                flow606 = '',
                pressure608 = '',
                flow608 = '',
                pressure610 = '',
                flow610 = '',
                highPressure = '',
                highPressureFlow = '',
                highPressureLevel = '',
                washingPressure = '',
                washingFlow = '',
                backWashingPressure = '',
                backWashingFlow = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.measureTime = measureTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.thickenerRakePressure = thickenerRakePressure;
            this.pressure606 = pressure606;
            this.flow606 = flow606;
            this.pressure608 = pressure608;
            this.flow608 = flow608;
            this.pressure610 = pressure610;
            this.flow610 = flow610;
            this.highPressure = highPressure;
            this.highPressureFlow = highPressureFlow;
            this.highPressureLevel = highPressureLevel;
            this.washingPressure = washingPressure;
            this.washingFlow = washingFlow;
            this.backWashingPressure = backWashingPressure;
            this.backWashingFlow = backWashingFlow;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingThickenerPump();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.measureTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'thickenerRakePressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.thickenerRakePressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pressure606',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.pressure606',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'flow606',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.flow606',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pressure608',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.pressure608',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'flow608',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.flow608',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pressure610',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.pressure610',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'flow610',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.flow610',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'highPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.highPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'highPressureFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.highPressureFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'highPressureLevel',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.highPressureLevel',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'washingPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.washingPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'washingFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.washingFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'backWashingPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.backWashingPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'backWashingFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.backWashingFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            measureTimeRteFilter : '',
            measureTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            thickenerRakePressureFilter : '',
            pressure606Filter : '',
            flow606Filter : '',
            pressure608Filter : '',
            flow608Filter : '',
            pressure610Filter : '',
            flow610Filter : '',
            highPressureFilter : '',
            highPressureFlowFilter : '',
            highPressureLevelFilter : '',
            washingPressureFilter : '',
            washingFlowFilter : '',
            backWashingPressureFilter : '',
            backWashingFlowFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'measureTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.filter.measureTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'measureTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.filter.measureTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'measureTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.measureTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'thickenerRakePressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.thickenerRakePressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'pressure606',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.pressure606',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'flow606',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.flow606',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'pressure608',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.pressure608',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'flow608',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.flow608',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'pressure610',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.pressure610',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'flow610',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.flow610',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'highPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.highPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'highPressureFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.highPressureFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'highPressureLevel',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.highPressureLevel',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'washingPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.washingPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'washingFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.washingFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'backWashingPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.backWashingPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'backWashingFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.backWashingFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingThickenerPump.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingThickenerPump, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        